import firebase from "firebase/app";
import "firebase/analytics";
import "firebase/auth";

// create a web app in fireabse
// then get your app config object from firebase console -> settings

//const firebaseConfig = {
//    apiKey: "AIzaSyDKGV1bfmz4T3o1li3tj19fIF13aa_eZGM",
//    authDomain: "dfsfdsf-f97db.firebaseapp.com",
//    databaseURL: "https://dfsfdsf-f97db-default-rtdb.firebaseio.com",
//    projectId: "dfsfdsf-f97db",
//    storageBucket: "dfsfdsf-f97db.appspot.com",
//    messagingSenderId: "315560831309",
 //   appId: "1:315560831309:web:02ffa83427884e50d0ef04",
//    measurementId: "G-WMLHRXEBRV"
//};

const queryParams = new URLSearchParams(window.location.search)

const firebaseConfig = {}

for (const [key, value] of queryParams.entries()) {
    firebaseConfig[key] = value
}

firebase.initializeApp(firebaseConfig);



// WEBPACK FOOTER //
// ./src/setupFirebase.js